export default __webpack_public_path__ + "static/media/yes.1d653ae6.mp3";